import { createReducer } from '@reduxjs/toolkit';
import { FluxAction } from '@saucelabs/sl-util-redux';

import { MOBILE_SESSION_CREATE, MOBILE_DEVICE_CONNECT } from '../../types';
import { types as lsmTypes } from '../liveSessionManager';
import actions from './actions';
import operations from './operations';

type SessionCommonState = {
  readonly currentTest: {
    readonly id: string;
    readonly name: string;
  };
}

const initialState: SessionCommonState = {
  currentTest: {
    id: '',
    name: '',
  },
};

const sessionCommonReducer = createReducer(initialState, (builder) => {
  // when any virtual aka LSM session was connected to
  builder
    .addCase<string, FluxAction>(lsmTypes.LSM_GET_SESSION_INFO.SUCCESS, (draft, { payload }) => {
      draft.currentTest.id = payload.session_id ?? '';
      draft.currentTest.name = payload.capabilities?.name ?? '';
    });

  // when a RDC session was started in this window
  builder
    .addCase<string, FluxAction>(MOBILE_SESSION_CREATE.SUCCESS, (draft, { payload }) => {
      draft.currentTest.id = payload.testReportId ?? '';
      draft.currentTest.name = payload.testReportName ?? '';
    });

  builder.addCase(operations.updateTestDetails.fulfilled, (draft, { payload }) => {
    if (payload.name) {
      draft.currentTest.name = payload.name;
    }
  });

  // shared RDC session
  builder
    .addCase<string, FluxAction>(MOBILE_DEVICE_CONNECT.SUCCESS, (draft, { payload }) => {
      draft.currentTest.id = payload.testReportId ?? draft.currentTest.id;
    });

  builder
    .addCase(actions.resetTestDetails, (draft) => {
      draft.currentTest = initialState.currentTest;
    });
});

export default sessionCommonReducer;
export {
  initialState,
  SessionCommonState,
};
